// @flow
import {
  ADMIN_UPDATE_COMPANY_LIST,
  ADMIN_UPDATE_COMPANY_LICENCE,
  ADMIN_UPDATE_COMPANY_FACEBASE,
  ADMIN_UPDATE_COMPANY_USER,
  ADMIN_UPDATE_COMPANY_CHILD,
  ADMIN_UPDATE_TIER,
  ADMIN_GET_COMPANY_LIST,
  ADMIN_EDIT_COMPANY_FACEBASE,
  ADMIN_REMOVE_USER_FROM_COMPANY,
  ADMIN_DELETE_LICENCE_FROM_COMPANY,
  ADMIN_REMOVE_COMPANY_ITEM,
  ADMIN_UPDATE_LICENCE_LIST
} from "../../global/actions/actionNames";

const initialState = {
  companies: null,
  tiers: null
};

const companyReducers = (state: * = initialState, actions: *): * => {
  switch (actions.type) {
    case ADMIN_GET_COMPANY_LIST:
      if (actions.companies !== null) {
        const companies = actions.companies;
        return {
          ...state,
          companies: companies
        };
      }
      return state;

    case ADMIN_UPDATE_COMPANY_LIST:
      if (actions.company !== null && actions.company.id !== null) {
        let companies = state.companies === null ? [] : [...state.companies];
        if (companies.length > 0) {
          let index = companies.findIndex(x => x.id === actions.company.id);
          if (index > -1) {
            companies[index] = actions.company;
          } else {
            companies.push(actions.company);
          }
        } else {
          companies.push(actions.company);
        }

        return {
          ...state,
          companies: companies
        };
      }
      return state;

    case ADMIN_UPDATE_COMPANY_LICENCE:
      if (actions.data !== null && actions.companyId !== null) {
        let companies = [...state.companies];
        let i = companies.findIndex(x => x.id === actions.companyId);
        let company = { ...companies[i] };
        let licences = [...company.licences.edges];
        if (licences.length > 0) {
          let index = licences.findIndex(x => x.node.id === actions.data.id);
          if (index > -1) {
            licences[index].node = actions.data;
          } else {
            licences.push({ node: actions.data });
          }
        } else {
          licences.push({ node: actions.data });
        }
        company.licences = { edges: licences };
        companies[i] = company;
        return {
          ...state,
          companies: companies
        };
      }
      return state;

    case ADMIN_DELETE_LICENCE_FROM_COMPANY:
      if (actions.licenceid !== null && actions.companyId !== null) {
        let companies = [...state.companies];
        let i = companies.findIndex(x => x.id === actions.companyId);
        let company = { ...companies[i] };
        let licences = [...company.licences.edges];
        if (licences.length > 0) {
          let index = licences.findIndex(x => x.node.id === actions.licenceid);
          if (index > -1) {
            licences.splice(index, 1);
          }
        }
        company.licences = { edges: licences };
        companies[i] = company;
        return {
          ...state,
          companies: companies
        };
      }
      return state;

    case ADMIN_UPDATE_COMPANY_FACEBASE:
      if (actions.facebase !== null && actions.companyId !== null) {
        let companies = [...state.companies];
        let i = companies.findIndex(x => x.id === actions.companyId);
        let company = { ...companies[i] };
        let facebases = [...company.facebases.edges];
        if (facebases.length > 0) {
          let index = facebases.findIndex(
            x => x.node.id === actions.facebase.id
          );
          if (index > -1) {
            facebases[index].node = actions.facebase;
          } else {
            facebases.push({ node: actions.facebase });
          }
        } else {
          facebases.push({ node: actions.facebase });
        }
        company.facebases = { edges: facebases };
        companies[i] = company;
        return {
          ...state,
          companies: companies
        };
      }
      return state;

    case ADMIN_UPDATE_COMPANY_USER:
      if (actions.data !== null && actions.companyId !== null) {
        let companies = [...state.companies];
        let i = companies.findIndex(x => x.id === actions.companyId);
        let company = { ...companies[i] };
        let users = [...company.users.edges];
        if (users.length > 0) {
          let index = users.findIndex(x => x.node.id === actions.data.id);
          if (index > -1) {
            users[index].node = actions.data;
          } else {
            users.push({ node: actions.data });
          }
        } else {
          users.push({ node: actions.data });
        }
        company.users = { edges: users };
        companies[i] = company;
        return {
          ...state,
          companies: companies
        };
      }
      return state;

    case ADMIN_REMOVE_USER_FROM_COMPANY:
      if (actions.userId !== null && actions.companyId !== null) {
        let companies = state.companies ? [...state.companies] : [];
        let i = companies.findIndex(x => x.id === actions.companyId);
        let company = { ...companies[i] };
        let users = [...company.users.edges];
        if (users.length > 0) {
          let index = users.findIndex(
            x => x.node.cognitoUuid === actions.userId
          );
          if (index > -1) {
            users.splice(index, 1);

            company.users = { edges: users };
            companies[i] = company;
            return {
              ...state,
              companies: companies
            };
          }
        }
      }
      return state;

    case ADMIN_UPDATE_COMPANY_CHILD:
      if (actions.data !== null && actions.parentId !== null) {
        let companies = [...state.companies];
        let i = companies.findIndex(x => x.id === actions.parentId);
        let company = { ...companies[i] };
        let children = [...company.children.edges];
        if (children.length > 0) {
          let index = children.findIndex(x => x.node.id === actions.data.id);
          if (index > -1) {
            children[index].node = actions.data;
          } else {
            children.push({ node: actions.data });
          }
        } else {
          children.push({ node: actions.data });
        }
        company.children = { edges: children };
        companies[i] = company;
        return {
          ...state,
          companies: companies
        };
      }
      return state;

    case ADMIN_UPDATE_TIER:
      let tiers = state.tiers === null ? [] : [...state.tiers];
      if (actions.tier !== null && actions.tier.id !== null) {
        if (tiers.length > 0) {
          let index = tiers.findIndex(x => x.id === actions.tier.id);
          if (index > -1) {
            tiers[index] = actions.tier;
          } else {
            tiers.push(actions.tier);
          }
        } else {
          tiers.push(actions.tier);
        }
      }
      return {
        ...state,
        tiers: tiers
      };

    case ADMIN_EDIT_COMPANY_FACEBASE:
      if (actions.facebase !== null && actions.companyId !== null) {
        let companies = [...state.companies];
        let i = companies.findIndex(x => x.uuid === actions.companyId);
        let company = { ...companies[i] };
        let facebases = [...company.facebases.edges];
        if (facebases.length > 0) {
          let index = facebases.findIndex(
            x => x.node.uuid === actions.facebase.uuid
          );
          if (index > -1) {
            let id = facebases[index].node.id;
            let facebase = { id: id, ...actions.facebase };
            facebases[index].node = facebase;
            company.facebases = { edges: facebases };
            companies[i] = company;
            return {
              ...state,
              companies: companies
            };
          }
        }
      }
      return state;

    case ADMIN_REMOVE_COMPANY_ITEM:
      if (actions.companyId !== null && state.companies !== null) {
        let companies = [...state.companies];
        let index = companies.findIndex(x => x.id === actions.companyId);
        if (index > -1) {
          companies.splice(index, 1);
        }

        return {
          ...state,
          companies: companies
        };
      }
      return state;

    case ADMIN_UPDATE_LICENCE_LIST:
      if (
        actions.value !== undefined &&
        actions.licenceId !== undefined &&
        actions.fieldName !== undefined &&
        actions.companyId !== undefined
      ) {
        let companies = [...state.companies];
        let i = companies.findIndex(x => x.id === actions.companyId);
        let company = { ...companies[i] };
        let licences = [...company.licences.edges];
        if (licences.length > 0) {
          let index = licences.findIndex(x => x.node.id === actions.licenceId);
          if (index > -1) {
            licences[index].node[actions.fieldName] = actions.value;
            company.licences = { edges: licences };
            companies[i] = company;
            return {
              ...state,
              companies: companies
            };
          }
        }
      }
      return state;

    default:
      return state;
  }
};
export default companyReducers;
